import React, { useState, useEffect } from "react";
import axios from "axios";
import "./GetPerformaInvoicePage.css";  // Custom CSS file for styles

const GetPerformaInvoicePage = () => {
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch the Performa Invoice data from the backend
  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        const response = await axios.get("https://agpipefitting.org.et/api/performa-invoice/1"); // Update with the correct endpoint
        setInvoiceData(response.data);
      } catch (err) {
        setError("We encountered an issue while loading the invoice details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoiceData();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <span>Loading your invoice details...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <span>{error}</span>
      </div>
    );
  }

  return (
    <div className="invoice-page-container">
      <header className="invoice-header">
        <h1 className="invoice-title">Performa Invoice for Pipe Fitting Products</h1>
        <div className="invoice-meta">
          <p><strong>Company:</strong> {invoiceData.companyName}</p>
          <p><strong>Invoice No:</strong> {invoiceData.invoiceNo} | <strong>Issue Date:</strong> {invoiceData.issueDate}</p>
        </div>
      </header>

      <div className="invoice-content">
        <section className="invoice-client-info">
          <h2>Client Information</h2>
          <p><strong>Name:</strong> {invoiceData.customerName}</p>
          <p><strong>Company Address:</strong> {invoiceData.customerAddress}</p>
          <p><strong>Contact No:</strong> {invoiceData.customerContact}</p>
          <p><strong>Email:</strong> {invoiceData.customerEmail}</p>
        </section>

        <section className="invoice-items">
          <h2>Requested Products</h2>
          <table className="invoice-items-table">
            <thead>
              <tr>
                <th>S/N</th>
                <th>Product Name</th>
                <th>Description</th>
                <th>Product Code</th>
                <th>Unit</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              {invoiceData.products.map((product, index) => (
                <tr key={index}>
                  <td>{product.sn}</td>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td>{product.productCode}</td>
                  <td>{product.unit}</td>
                  <td>{product.quantity}</td>
                  <td>{product.unitPrice}</td>
                  <td>{product.totalPrice}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="invoice-summary">
          <h2>Summary</h2>
          <div className="summary-row">
            <span><strong>Subtotal:</strong> {invoiceData.subtotal}</span>
            <span><strong>VAT (15%):</strong> {invoiceData.vat}</span>
            <span><strong>Total Amount (including VAT):</strong> {invoiceData.totalAmount}</span>
          </div>
        </section>

        <section className="invoice-terms">
          <h2>Terms and Conditions</h2>
          <p><strong>Delivery Time:</strong> {invoiceData.deliveryTime}</p>
          <p><strong>Place of Delivery:</strong> {invoiceData.deliveryPlace}</p>
          <p><strong>Payment Terms:</strong> {invoiceData.paymentTerms}</p>
          <p><strong>Price Validity:</strong> {invoiceData.priceValidity}</p>
        </section>

        <section className="invoice-approval">
          <h2>Approval</h2>
          <p><strong>Prepared By:</strong> {invoiceData.preparedBy}</p>
          <p><strong>Approved By:</strong> {invoiceData.approvedBy}</p>
        </section>

        <div className="invoice-actions">
          <button onClick={() => window.print()} className="print-button">Print Invoice</button>
          <button onClick={() => window.location.href = "/dashboard"} className="back-button">Back to Dashboard</button>
        </div>
      </div>
    </div>
  );
};

export default GetPerformaInvoicePage;
